import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { FaTachometerAlt, FaBoxOpen, FaTags, FaClipboardList, FaSignOutAlt, FaStore } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../components/LanguageSwitcher"; // استدعاء زرار اللغة

export default function AdminLayout() {
    const location = useLocation();
    const nav = useNavigate();
    const { t } = useTranslation(); // تفعيل الترجمة

    const menu = [
        { name: t("admin_menu_dashboard"), path: "/admin/dashboard", icon: <FaTachometerAlt /> },
        { name: t("admin_menu_orders"), path: "/admin/orders", icon: <FaClipboardList /> },
        { name: t("admin_menu_products"), path: "/admin/products", icon: <FaBoxOpen /> },
        { name: t("admin_menu_categories"), path: "/admin/categories", icon: <FaTags /> },
    ];

    const logout = () => {
        localStorage.removeItem("auth");
        nav("/login");
    };

    return (
        <div className="d-flex" style={{ minHeight: "100vh", backgroundColor: "#f8f9fc" }}>
            {/* Sidebar */}
            <div className="bg-dark text-white p-3 d-flex flex-column shadow" style={{ width: "260px", zIndex: 1000 }}>
                <Link to="/" className="text-white text-decoration-none d-flex align-items-center mb-4 mt-2 px-2">
                    <FaStore className="fs-3 me-3 text-primary" />
                    <span className="fs-4 fw-bold">{t("admin_store")}</span>
                </Link>

                <hr className="bg-secondary mb-4 opacity-25" />

                <ul className="nav nav-pills flex-column mb-auto gap-2">
                    {menu.map((item) => {
                        const isActive = location.pathname.includes(item.path);
                        return (
                            <li key={item.path} className="nav-item">
                                <Link
                                    to={item.path}
                                    className={`nav-link d-flex align-items-center text-white p-3 rounded-3 transition-all ${isActive ? "bg-primary shadow-sm fw-bold" : "hover-bg-secondary"}`}
                                >
                                    <span className="me-3 fs-5">{item.icon}</span>
                                    {item.name}
                                </Link>
                            </li>
                        );
                    })}
                </ul>

                <hr className="bg-secondary mt-4 opacity-25" />
                <button onClick={logout} className="btn btn-danger w-100 d-flex align-items-center justify-content-center py-2 fw-bold">
                    <FaSignOutAlt className="me-2" /> {t("admin_logout")}
                </button>
            </div>

            {/* Content Area */}
            <div className="flex-grow-1 d-flex flex-column overflow-hidden">
                {/* Topbar */}
                <div className="bg-white shadow-sm px-4 py-3 d-flex justify-content-between align-items-center z-1">
                    <h5 className="m-0 text-muted fw-bold">{t("admin_panel")}</h5>

                    <div className="d-flex align-items-center">
                        <LanguageSwitcher /> {/* زرار اللغة هنا */}
                        <div className="d-flex align-items-center cursor-pointer ms-3 border-start ps-3">
                            <img src="https://ui-avatars.com/api/?name=Admin&background=0D6EFD&color=fff" alt="Admin" className="rounded-circle shadow-sm me-3" width="45" />
                            <span className="fw-bold text-dark">{t("admin_system_admin")}</span>
                        </div>
                    </div>
                </div>

                {/* Outlet */}
                <div className="px-4 py-4 overflow-auto flex-grow-1">
                    <Outlet />
                </div>
            </div>

            <style>{`
                .hover-bg-secondary:hover { background-color: rgba(255,255,255,0.05); }
                .transition-all { transition: all 0.3s ease; }
                .cursor-pointer { cursor: pointer; }
            `}</style>
        </div>
    );
}